/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react'
import {
  Box,
  Button,
  Modal,
  Tooltip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
} from '@mui/material'
import { useStyles } from '../CaseDiagnosisStyles'
import { RootState } from '../../../reducers'
import { useSelector, useDispatch } from 'react-redux'
import PreviewReport from './PreviewReport'
import { saveDraftReportData, setSaveState, setPDFBytes, addListData, getDraftReportData } from '../../../actions'
import { Check as CheckIcon, Clear as ClearIcon } from '@mui/icons-material'
import PreviewIcon from '@mui/icons-material/Preview'
import SuccessSnackBar from '../../HOC/SuccesSnackBar'
import ErrorSnackBar from '../../HOC/ErrorSnackBar'
import CommentsSelected from './CommentsSelected'
import RestartAltIcon from '@mui/icons-material/RestartAlt'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'

export default function SelectionsMade({ trfBarcode, location, pseudoProcedureCode }) {
  const classes = useStyles()
  const dispatch = useDispatch()
  const [open, setOpen] = useState(false)
  const selectedList = useSelector((state: RootState) => state.setReportDiagnosisData)
  const selectedCategorizedList = useSelector((state: RootState) => state.setCategorizedData)
  const saveState = useSelector((state: RootState) => state.getSaveState)
  const { procedureCodeId } = useSelector((state: RootState) => state.getCaseData)
  const sampleInfoTree = useSelector((state: RootState) => state.addSampleLocationData)
  const [openSuccessSnackBar, setOpenSuccessSnackBar] = useState(false)
  const reportOptions = useSelector((state: RootState) => state.setCaseDiagnosis)
  const { re_save_draft_success, re_save_draft_error } = useSelector((state: RootState) => state.saveDraftReport)
  const [isPreviewOpen, setPreviewOpen] = useState(false)
  const savedCommentData = useSelector((state: RootState) => state.setDraftReportData)
  const reportData = useSelector((state: RootState) => state.setReportData)
  const [resetDialogOpen, setResetDialogOpen] = useState(false)
  const [isNoRecords, setNoRecords] = useState(false)
  const [pdfUrl, setPdfUrl] = useState('')
  const [isRecutValidationError, setRecutValidationError] = useState(false)
  const { role } = useSelector((state: RootState) => state.userLogin)
  const [currentReportOptions, setCurrentReportOptions] = useState([] as any)
  const getButtonClassName = () =>
    role == 'NL_WOMA_ADMIN' || saveState.payload ? `${classes.disableSaveBtn} ` : `${classes.saveButton}`

  useEffect(() => {
    if (reportOptions && reportOptions.payload && reportOptions.payload.length && pseudoProcedureCode != '') {
      const procedureCodeReportOptions = reportOptions.payload.filter(
        (procObject) => procObject.procedureCode === pseudoProcedureCode,
      )
      if (procedureCodeReportOptions.length && procedureCodeReportOptions[0].reportOptions) {
        setCurrentReportOptions(procedureCodeReportOptions[0].reportOptions)
      }
    }
  }, [reportOptions, pseudoProcedureCode])

  const handleClose = async () => {
    setOpen(false)
    setPdfUrl('')
    await dispatch(setPDFBytes({ pdfUrl: '' }))
  }
  const handleOpen = () => {
    setPreviewOpen(true)
  }

  useEffect(() => {
    if (isPreviewOpen) {
      const isRecutValidated = validateRecutsData()
      if (isRecutValidated) {
        handleFlatten()
        setPreviewOpen(false)
        dispatch(setPDFBytes({ pdfUrl: '' }))
        setOpen(true)
      } else {
        setPreviewOpen(false)
        dispatch(setPDFBytes({ pdfUrl: '' }))
        setRecutValidationError(true)
        setOpen(false)
        // setError(true) //todo
      }
    }
  }, [isPreviewOpen])

  const handleFlatten = async () => {
    const flattenedSelectedList = selectedList.payload.map((o) => {
      //no of brackets in the label shud be equal to length of selectedSuboptions
      if (
        (!o.displayValue || (o.displayValue && o.displayValue.indexOf('-1') !== -1)) &&
        o.label.indexOf('[') !== -1 &&
        o.selectedSuboptions &&
        o.label.split('[').length - 1 === Object.keys(o.selectedSuboptions).length
      ) {
        let flattenedString = o.label
        const selectedSuboptionValues = Object.values(o.selectedSuboptions)
        const selectedSuboptionKeys = Object.keys(o.selectedSuboptions)
        selectedSuboptionKeys.forEach((element, index) => {
          flattenedString = flattenedString.replace(element, selectedSuboptionValues[index])
        })
        o.displayValue = flattenedString
        dispatch(setSaveState({ isSaveDisabled: false }))
      } else {
        if (!isPreviewOpen) dispatch(setSaveState({ isSaveDisabled: true }))
      }
      return o
    })
    await dispatch(addListData(flattenedSelectedList, true))
    return flattenedSelectedList
  }

  const handleSaveComments = async () => {
    let calloutDecision = savedCommentData.calloutDecision
    if (selectedList.payload) {
      if (selectedList.payload && selectedList.payload.length) {
        selectedList.payload.map((listItem) => {
          calloutDecision = listItem.callout_required || calloutDecision
        })
      }
    }
    await handleFlatten()
    const reportBuilder = savedCommentData.reportBuilder ? savedCommentData.reportBuilder : {}
    reportBuilder[location] = selectedCategorizedList.payload
    const currentLocationData = sampleInfoTree['payload'].filter((item) => item.location === location)
    const validChildren = currentLocationData[0].children
    const collectionPlaces = [] as any
    validChildren.map((obj) => {
      if (obj.collectionPlace) {
        collectionPlaces.push(obj.collectionPlace)
      }
    })
    if (collectionPlaces.length) {
      if (collectionPlaces.length > 1) {
        reportBuilder[location].collectionPlace = collectionPlaces.join('|')
      } else {
        reportBuilder[location].collectionPlace = collectionPlaces[0]
      }
    }
    await dispatch(
      saveDraftReportData({
        trfBarcode: trfBarcode,
        reportBuilder: reportBuilder,
        consultedPats:
          savedCommentData.consultedPats && savedCommentData.consultedPats.length ? savedCommentData.consultedPats : [],
        calloutDecision: calloutDecision,
      }),
    )
    setOpenSuccessSnackBar(true)
    setTimeout(() => setOpenSuccessSnackBar(false), 2000)
    dispatch(setSaveState({ isSaveDisabled: true }))
    dispatch(getDraftReportData({ trfBarcode: trfBarcode }))
  }

  const handleResetComments = async () => {
    if (selectedList.payload) {
      Object.keys(selectedList.payload).map((key) => {
        if (selectedList.payload[key] && selectedList.payload[key].length) {
          selectedList.payload[key].splice(0, selectedList.payload[key].length)
        }
      })
    }
    selectedCategorizedList.payload = {}
    dispatch(addListData([], true))
    dispatch(setSaveState({ isSaveDisabled: false }))
    setResetDialogOpen(false)
  }

  const handleResetDialogClose = () => {
    setResetDialogOpen(false)
  }

  const validateRecutsData = () => {
    const slideDataObject = {} as any
    if (reportData && reportData.sampleInfo && reportData.sampleInfo.sampleInfoTree) {
      for (let i = 0; i < reportData.sampleInfo.sampleInfoTree.length; i++) {
        slideDataObject.slideData = reportData.sampleInfo.sampleInfoTree[i]
        if (slideDataObject.slideData) {
          slideDataObject.slideData.children.forEach((parentObject) => {
            const stainNamesData = [] as any
            if (
              parentObject &&
              parentObject.children &&
              parentObject.children.length &&
              parentObject.children[0] &&
              parentObject.children[0].children &&
              parentObject.children[0].children.length
            ) {
              parentObject.children[0].children.forEach((object) => {
                if (!object.inactiveReason) stainNamesData.push(object.sampleStain)
              })
            }
            if (parentObject.children && parentObject.children.length) {
              parentObject.children.forEach((object) => {
                if (!object.inactiveReason) stainNamesData.push(object.sampleStain)
              })
            }
            const duplicateStains = stainNamesData.filter(
              (item, index) => item !== undefined && stainNamesData.indexOf(item) !== index,
            )
            if (duplicateStains.length) {
              return false
            }
          })
        }
      }
    }
    return true
  }

  const handleRecutsErrorClose = () => {
    setRecutValidationError(false)
  }

  return (
    <>
      {openSuccessSnackBar && re_save_draft_success && <SuccessSnackBar message="Succesfully saved draft" />}
      {openSuccessSnackBar && re_save_draft_error && <ErrorSnackBar message="Failed to save draft" />}
      <Box style={{ marginTop: '0px', height: '100%' }}>
        <Box className={classes.selectionsMade}>
          <div className={classes.selectionsMadeTitle}>Selected Comments</div>
          <div className={classes.selectionContainer}>
            {currentReportOptions &&
              currentReportOptions.map((reportOption, optionIndex) => {
                return (
                  <div className={classes.section} style={{ marginLeft: '0px' }} key={optionIndex}>
                    <Accordion defaultExpanded={true}>
                      <AccordionSummary
                        sx={{ backgroundColor: 'rgba(146, 187, 204, 0.55)' }}
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                      >
                        <div className={classes.sectionTitle}>{reportOption.category}</div>
                      </AccordionSummary>
                      <AccordionDetails>
                        <div className={classes.diagnosisContainer}>
                          {selectedCategorizedList.payload &&
                          selectedCategorizedList.payload[reportOption.category] &&
                          selectedCategorizedList.payload[reportOption.category].length ? (
                            selectedCategorizedList.payload[reportOption.category].map((reportItem, index) => {
                              return (
                                <>
                                  <div key={index}>
                                    <CommentsSelected item={reportItem} index={index} location={location} />
                                  </div>
                                </>
                              )
                            })
                          ) : (
                            <p style={{ margin: '0px' }}>No records are selected</p>
                          )}
                        </div>
                      </AccordionDetails>
                    </Accordion>
                  </div>
                )
              })}
          </div>
          <div className={classes.buttonActions}>
            <Tooltip title="Save all the updates" placement="top-start">
              <Button className={getButtonClassName()} onClick={handleSaveComments} endIcon={<CheckIcon />}>
                Save
              </Button>
            </Tooltip>
            <Tooltip title="Preview report for current sample" placement="top-start">
              <Button className={classes.releaseButton} onClick={handleOpen} endIcon={<PreviewIcon />}>
                Preview
              </Button>
            </Tooltip>
            <Tooltip title="Remove all case diagnosis and comments selected" placement="top-start">
              <Button
                className={classes.releaseButton}
                onClick={() => {
                  setResetDialogOpen(true)
                }}
                endIcon={<RestartAltIcon />}
              >
                CLEAR ALL
              </Button>
            </Tooltip>
          </div>
          <Dialog
            open={resetDialogOpen}
            onClose={handleResetDialogClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            classes={{ paper: classes.resetDialogHeight }}
          >
            <DialogTitle className={classes.dialogTitle}>Clear all selections for this location</DialogTitle>
            <DialogContent className={classes.discardDialogContent}>
              <DialogContentText id="alert-dialog-description">
                This will clear all the selected case-diagnosis and comments. Do you really want to reset them?
              </DialogContentText>
            </DialogContent>

            <DialogActions className={classes.buttonActions}>
              <Button onClick={handleResetComments} className={classes.saveButton} autoFocus endIcon={<CheckIcon />}>
                Confirm
              </Button>
              <Button
                className={`${classes.buttonMargin}`}
                onClick={handleResetDialogClose}
                variant="outlined"
                endIcon={<ClearIcon />}
              >
                Cancel
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog fullWidth maxWidth="sm" open={isRecutValidationError} onClose={handleRecutsErrorClose}>
            <DialogTitle className={classes.dialogTitle}>Slides validation error</DialogTitle>
            <Divider />
            <DialogContent>
              <>
                <ErrorOutlineIcon style={{ color: 'red', width: '50px', verticalAlign: 'middle' }} />
                Duplicate slides are included in the report, please check slide diagnosis inclusion and try again.
              </>
            </DialogContent>
            <DialogActions className={classes.buttonActions}>
              <Button
                className={`${classes.buttonMargin}`}
                variant="outlined"
                endIcon={<ClearIcon />}
                onClick={handleRecutsErrorClose}
              >
                Close
              </Button>
            </DialogActions>
          </Dialog>
        </Box>
      </Box>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box>
          <PreviewReport
            trfBarcode={trfBarcode}
            handleClose={handleClose}
            location={location}
            pdfUrl={pdfUrl}
            setPdfUrl={setPdfUrl}
          />
        </Box>
      </Modal>
    </>
  )
}
